<template>
  <div>
    <component
      :is="slice.slice_type"
      v-for="(slice, sliceId) in moduleData.body"
      :key="sliceId"
      :slice="slice"
    />
  </div>
</template>

<script>
import { Hero, CounterBanner } from '@@/shared-slices'

import { PressContent, HighlightBlockSlice } from './components'

export default {
  name: 'PressHubModule',

  components: {
    press_content: PressContent,
    Hero,
    highlight_block: HighlightBlockSlice,
    counter_banner: CounterBanner,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
    articles: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" module></style>
